import React from "react";
import { Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import { AuthProvider } from "./auth/AuthContext";
import RequireAdmin from "./auth/RequireAdmin";
import Landing from "./pages/Landing";
import Rsvp from "./pages/Rsvp";
import Login from "./pages/Login";
import Expenses from "./pages/admin/Expenses";
import Guests from "./pages/admin/Guests";
import Settings from "./pages/admin/Settings";
import AdminHome from "./pages/admin/AdminHome";
import NotFound from "./pages/NotFound";
import Faq from "./pages/Faq";
import Timeline from "./pages/Timeline";
import Travels from "./pages/Travels";
import { isRsvpEnabled } from "./features";

export default function App() {
  return (
    <AuthProvider>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/rsvp" element={isRsvpEnabled() ? <Rsvp /> : <NotFound />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/timeline" element={<Timeline />} />
          <Route path="/travels" element={<Travels />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminHome />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/expenses"
            element={
              <RequireAdmin>
                <Expenses />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/guests"
            element={
              <RequireAdmin>
                <Guests />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <RequireAdmin>
                <Settings />
              </RequireAdmin>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </AuthProvider>
  );
}
